import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import { getTranslateByKey } from '@/main/services/utils';

import Button from '@/main/components/shared/button/button';
import { AreaButton } from '@/main/components/shared/styles';
import { TermsOfUseFilterRequest } from '@/main/models/request';
import FiltersTermsOfUse from '@/main/screens/registration/termsOfUse/components/filtersTermsOfUse/filtersTermsOfUse';
import GridTermsOfUse from '@/main/screens/registration/termsOfUse/components/gridTermsOfUse/gridTermsOfUse';
import ModalRegisterTermsOfUse from '@/main/screens/registration/termsOfUse/components/modalRegisterTermsOfUse/modalRegisterTermsOfUse';
import { ITermsOfUseFilterFormOutput } from '@/main/screens/registration/termsOfUse/termsOfUseUtils';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import { StatusRegisterEnum } from '@/main/services/enum/StatusRegisterEnum';
import { isNullUndefined } from '@/main/services/reducerUtils';
import { useState } from 'react';
import * as S from './components/filtersTermsOfUse/styles';
import { withQueryparams } from '@/main/components/core/queryParams/queryparams';

const ID_BASE_COMPONENTS = 'id-searchTermsOfUse';

function TermsOfUseScreen() {
  const [filterRequest, setFilterRequest] =
    useState<TermsOfUseFilterRequest | null>(null);
  const [searchId, setSearchId] = useState(0);
  const [showFilters, setShowFilters] = useState(true);
  const [openModalRegister, setOpenModalRegister] = useState(false);
  const [editGuid, setEditGuid] = useState<string | undefined>(undefined);

  function handleSubmit(formInputs: ITermsOfUseFilterFormOutput) {
    const idStatus = Number(formInputs.statusRegister.key);
    const request: TermsOfUseFilterRequest = {
      countryGuid: String(formInputs.country.key),
      cultureGuid: String(formInputs.culture.key),
      idCompanyType: Number(formInputs.companyType.key),
      idFileType: formInputs.fileType
        ? Number(formInputs.fileType?.key)
        : undefined,
      active: idStatus == StatusRegisterEnum.Active,
      idSystemApplication: Number(formInputs.systemApplication.key),
      companyGuids: formInputs.company.map(c => String(c.key)),
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize30
    };
    setFilterRequest(request);
    setSearchId(id => id + 1);
  }

  function handleClear() {
    setFilterRequest(null);
    setSearchId(id => id + 1);
  }

  function handleFilters() {
    setShowFilters(!showFilters);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function handleOpenModalRegister(guid?: string) {
    if (!isNullUndefined(guid)) {
      setEditGuid(guid);
    }
    setOpenModalRegister(true);
  }
  function handleCloseModal(refresh: boolean = false) {
    setEditGuid(undefined);
    setOpenModalRegister(false);

    if (!refresh) return;
    if (isNullUndefined(filterRequest)) return;
    const request = {
      ...filterRequest,
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize30
    };
    setFilterRequest(request);
    setSearchId(id => id + 1);
  }

  return (
    <ContainerScreen
      hasBackground
      title={`
      ${getTranslateByKey('information.registration')}
      ${' > '}
      ${getTranslateByKey('screen.acceptanceTerms')}`}>
      <S.Container>
        <AreaButton>
          <Button
            id={`${ID_BASE_COMPONENTS}-btn-filters`}
            onClick={handleFilters}>
            {getTranslateByKey('information.filters')}
          </Button>

          <Button
            id={`${ID_BASE_COMPONENTS}-btn-register`}
            onClick={() => handleOpenModalRegister()}>
            {getTranslateByKey('information.newTerm')}
          </Button>
        </AreaButton>

        <FiltersTermsOfUse
          showFilters={showFilters}
          onSubmit={handleSubmit}
          onClear={handleClear}
        />

        <GridTermsOfUse
          key={searchId}
          filter={filterRequest}
          handleEdit={handleOpenModalRegister}
        />

        <ModalRegisterTermsOfUse
          handleClose={handleCloseModal}
          isOpen={openModalRegister}
          fileImportGuid={editGuid}
        />
      </S.Container>
    </ContainerScreen>
  );
}

export default withQueryparams(TermsOfUseScreen);
